import React, { Component } from "react";
import { Link } from "react-router-dom";
import client from "@culturehq/client";
import { ActionButton, Badge, Icon } from "@culturehq/components";

import { errorService, t, Trans } from "app/utils";

import LazyEditorOutput from "components/editor/LazyEditorOutput";
import { TimeDiff } from "components/common/Time";
import ErrorMessage from "components/common/ErrorMessage";
import { getIcon } from "constants/tagsTypes";
import ChqModalConfirmDelete from "components/common/ChqModalConfirmDelete";

const ToggleFailed = ({ error }) => (
  <tr>
    <td colSpan="100">
      <ErrorMessage error={error} />
    </td>
  </tr>
);

class WidgetRow extends Component {
  state = { removed: false, error: null };

  handleDelete = async () => {
    const { widget: { id: announcementId } } = this.props;

    try {
      await client.deleteAnnouncement({ announcementId });
      this.setState({ removed: true });
    } catch (error) {
      errorService.error(error);
    }
  };

  handleEnabledToggle = async () => {
    const { widget } = this.props;

    try {
      await client.updateAnnouncement({
        announcementId: widget.id,
        active: !widget.active
      });

      this.setState({ removed: true });
    } catch (error) {
      this.setState({ error });
    }
  };

  render() {
    const { disabled, widget } = this.props;
    const { error, removed } = this.state;

    if (removed) {
      return null;
    }

    return (
      <>
        <tr data-id={widget.id} className={widget.active ? "" : "disabled"}>
          {!disabled && <td className="sortable__drag-handler" />}
          <td />
          <td>
            <TimeDiff time={widget.createdAt} />
          </td>
          <td>{widget.title}</td>
          <td className="max-width-300">
            <LazyEditorOutput output={widget.body} />
          </td>
          <td className="max-width-300">
            <div className="chq-ffd-tags">
              {(widget.announcementTags.length > 0)
                && widget.announcementTags.map(tag => tag.entity && (
                  <Badge key={tag.id}>
                    <Icon icon={getIcon(tag.entityType)} className="category-icon" />
                    {tag.entity.name}
                  </Badge>
                ))}
              {widget.announcementTags.length === 0 && <Trans>For You</Trans>}
            </div>
          </td>
          <td>
            <ActionButton onClick={this.handleEnabledToggle} className="pull-right">
              {widget.active ? t("Disable") : t("Enable")}
            </ActionButton>
            <Link className="link action pull-right" to={`/admin/widgets/${widget.id}/edit`}>
              <Trans>Edit</Trans>
            </Link>
            <ChqModalConfirmDelete
              onAccept={this.handleDelete}
              trigger={onTrigger => (
                <ActionButton onClick={onTrigger} className="pull-right">
                  <Trans>Delete</Trans>
                </ActionButton>
              )}
            >
              <Trans>Are you sure you would like to delete this widget?</Trans>
            </ChqModalConfirmDelete>
          </td>
        </tr>
        {error && <ToggleFailed error={error} />}
      </>
    );
  }
}

export default WidgetRow;
